import { FaEnvelopeOpenText, FaRegEnvelope } from "react-icons/fa";
import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SendOTP.scss";

export default function SendOTP({ email, onClose }) {
  const navigate = useNavigate();
  const inputs = useRef([]);
  const [isFilled, setIsFilled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(30); // ⏱ countdown in seconds
  const [resending, setResending] = useState(false);

  // 👇 Run once when component mounts
  useEffect(() => {
    if (inputs.current[0]) inputs.current[0].focus();
  }, []);

  // 👇 Run repeatedly for countdown updates
  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [countdown]);

  // 🔁 Resend OTP
  const handleResend = async () => {
    if (countdown > 0 || resending) return;

    try {
      setResending(true);
      setError("");

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/resend-verification`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setError(
          data.error || "Failed to resend verification. Try again later."
        );
        return;
      }

      setCountdown(30); // restart countdown
    } catch (err) {
      console.error(err);
      setError("Network error. Please try again later.");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="otp-container">
      <div className="otp-icon-wrapper">
        <FaEnvelopeOpenText />
      </div>
      <h2>CONFIRM YOUR EMAIL ADDRESS</h2>
      <span>
        We set a confirmation email to <b>{email}</b>.
        <br />
        check your email and click on <b>VERIFY EMAIL</b> button to continue.
      </span>

      <p>
        {" "}
        {error && <p style={{ color: "red" }}>{error}</p>}
        {countdown > 0 ? (
          <span style={{ color: "#888" }}>Resend in {countdown}s</span>
        ) : (
          <strong
            style={{
              color: "#007bff",
              cursor: "pointer",
            }}
            onClick={handleResend}
          >
            {resending ? "Sending..." : "Resend Email"}
          </strong>
        )}
      </p>
    </div>
  );
}
